// src/pages/Learn.jsx
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/learn-hub.css";

const FAQ_DATA = [
  {
    category: "Membership Basics",
    items: [
      {
        q: "What's the difference between Explore, Adventure and Elite memberships?",
        a: "Each level offers more days of access and higher vehicle trim levels.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/family_boat.png",
      },
      {
        q: "Can I upgrade Club levels during my term?",
        a: "Yes! You can upgrade at any time by paying the difference between membership tiers.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/72_2025_YFM70GPASD_DNME_US_00_YY_102613.jpg",
      },
      {
        q: "What happens to unused days at the end of my membership period?",
        a: "Unused days expire at the end of your annual membership period and do not roll over.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/75_2025_YXF10WRLSL_DBSC_YXE10WRLSL_DBSC_US_12_YY_95267.jpg",
      },
      {
        q: "Are memberships transferable to family members or friends?",
        a: "Your membership is personal to you as the primary account holder.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/82_2025_FX1900A-B_PRMN_NA_00_YY_03.jpg",
      },
      {
        q: "What's included in my membership fee vs. what costs extra?",
        a: "Your membership fee includes access days, GPS tracking, basic cleaning, maintenance and insurance.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/82_2026_FX1900B-C_DWBL_NA_00_YY_05.jpg",
      },
      {
        q: "Do I need to have a Driver’s License?",
        a: "A valid Canadian driver's license is required to become a member.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/A66I0036.jpg",
      },
      {
        q: "Do I need any special license to operate any specific vehicles?",
        a: "A Pleasure Craft Operator Card (PCOC) is recommended for boating.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/A66I0099.jpg",
      },
    ],
  },

  {
    category: "Booking & Availability",
    items: [
      {
        q: "How far in advance can I book a vehicle?",
        a: "All Club levels are given a specific booking class (1,2 or 3).",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/2690.png",
      },
      {
        q: "What if the vehicle I want isn't available?",
        a: "You can join a waitlist or select another similar vehicle.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/75_2026_YXE10WTZTM_YXE85WTZTM_YXE85WTZTM_BNS7_US_12_YY_57511.jpg",
      },
      {
        q: "How does the waitlist work?",
        a: "You will be notified automatically if the vehicle becomes available.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/82_2025_FX1900A-B_PRMN_NA_00_YY_03.jpg",
      },
      {
        q: "Can I extend my booking?",
        a: "Extensions are subject to availability.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/Boat_Banner.jpg",
      },
      {
        q: "Is there a limit to consecutive booking days?",
        a: "Booking limits depend on your membership class.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/towfiqu-barbhuiya-jpqyfK7GB4w-unsplash.jpg",
      },
    ],
  },

  {
    category: "Vehicle Access",
    items: [
      {
        q: "What types of vehicles are available?",
        a: "Travel trailers, powersports vehicles, and marine units.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/rv_banner.jpg",
      },
      {
        q: "Can I request a specific make or model?",
        a: "We allow selecting vehicle categories but not guaranteed models.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/brady-rogers-ZGRB8TMT6zQ-unsplash.jpg",
      },
      {
        q: "What condition will the vehicle be in?",
        a: "Vehicles are cleaned, inspected and fully fueled.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/A66I0036.jpg",
      },
      {
        q: "What if there's a mechanical issue?",
        a: "Contact concierge immediately and we will assist.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/Boat_Banner.jpg",
      },
      {
        q: "Are there mileage restrictions?",
        a: "Reasonable personal usage is included in membership.",
        image: "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/atv_picture.jpg",
      },
    ],
  },
];

const DEFAULT_IMAGE =
  "https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/Vehicles/Boat_Banner.jpg";



function slugify(str) {
  return String(str)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}

function makeExcerpt(answer, max = 150) {
  const s = String(answer || "").replace(/\s+/g, " ").trim();
  if (!s) return "";
  if (s.length <= max) return s;
  return `${s.slice(0, max - 1)}…`;
}

function Answer({ text }) {
  const lines = String(text || "").split("\n");
  const out = [];
  let list = [];
  let para = [];

  const flushList = (keyBase) => {
    if (!list.length) return;
    out.push(
      <ul key={`${keyBase}-ul`} className="learnInline__list">
        {list.map((li, i) => (
          <li key={`${keyBase}-li-${i}`}>{li}</li>
        ))}
      </ul>
    );
    list = [];
  };

  const flushPara = (keyBase) => {
    if (!para.length) return;
    out.push(
      <p key={`${keyBase}-p`} className="learnInline__p">
        {para.join(" ")}
      </p>
    );
    para = [];
  };

  lines.forEach((raw, idx) => {
    const trimmed = raw.replace(/\r/g, "").trim();
    const isBullet = trimmed.startsWith("- ");
    const isNumbered = /^\d+\.\s+/.test(trimmed);

    if (!trimmed) {
      flushList(`b${idx}`);
      flushPara(`p${idx}`);
      return;
    }

    if (isBullet) {
      flushPara(`p${idx}`);
      list.push(trimmed.replace(/^-+\s*/, ""));
      return;
    }

    if (isNumbered) {
      flushPara(`p${idx}`);
      list.push(trimmed.replace(/^\d+\.\s+/, ""));
      return;
    }

    flushList(`b${idx}`);
    para.push(trimmed);
  });

  flushList("end");
  flushPara("end");

  return <div className="learnInline__content">{out}</div>;
}

const RESOURCES = FAQ_DATA.flatMap((section) =>
  section.items.map((item, idx) => ({
    id: `${slugify(section.category)}-${idx}-${slugify(item.q).slice(0, 24)}`,
    group: section.category,
    title: item.q,
    image: item.image || DEFAULT_IMAGE,
    excerpt: makeExcerpt(item.a),
    answerText: item.a,
  }))
);

export default function Learn() {
  const [query, setQuery] = useState("");
  const [openKey, setOpenKey] = useState(null);
  const [expandedGroups, setExpandedGroups] = useState({});

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();

    return RESOURCES.filter((r) => {
      if (!q) return true;
      const hay = `${r.group} ${r.title} ${r.excerpt} ${r.answerText}`.toLowerCase();
      return hay.includes(q);
    });
  }, [query]);

  const groups = useMemo(() => {
    const map = new Map();
    filtered.forEach((r) => {
      if (!map.has(r.group)) map.set(r.group, []);
      map.get(r.group).push(r);
    });
    return Array.from(map.entries()).map(([group, items]) => ({ group, items }));
  }, [filtered]);

  const toggleGroup = (group) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };

  return (
    <div className="page learnHub">
      <section className="learnHubTop">
        <div className="learnHubTop__overlay" />
        <div className="container learnHubTop__inner">
          <div className="learnHubTop__kicker">Learn</div>
          <h1 className="learnHubTop__title">Learn</h1>
          <p className="learnHubTop__sub">
            Quick answers about memberships, booking, requirements, and policies.
          </p>

          <div className="learnHubSearch">
            <span className="learnHubSearch__icon">⌕</span>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search FAQs… (e.g., upgrade, waitlist, deposit, out of province)"
              className="learnHubSearch__input"
            />
            {query ? (
              <button
                type="button"
                className="learnHubSearch__clear"
                onClick={() => setQuery("")}
                aria-label="Clear search"
              >
                Clear
              </button>
            ) : null}
          </div>

          <div className="learnHubTop__ctaRow">
            <Link className="btn btn--primary" to="/clubs">
              Compare Memberships
            </Link>
            <Link className="btn btn--ghost" to="/vehicles">
              Browse Vehicles
            </Link>
          </div>
        </div>
      </section>

      <section className="learnHubBody">
        <div className="container">
          {groups.length === 0 ? (
            <div className="learnHubEmpty">
              <div className="learnHubEmpty__title">No results found</div>
              <p className="learnHubEmpty__text">
                Try a different search term (example: “waitlist”, “deposit”, “upgrade”).
              </p>
              <button type="button" className="btn btn--ghost" onClick={() => setQuery("")}>
                Reset search
              </button>
            </div>
          ) : (
            groups.map(({ group, items }) => {
              const showAll = !!expandedGroups[group];
              const visibleItems = showAll || query ? items : items.slice(0, 3);

              return (
                <div key={group} className="learnHubGroup">
                  <div className="learnHubGroup__head">
                    <h2 className="learnHubGroup__title">{group}</h2>
                    <div className="learnHubGroup__count">{items.length} FAQs</div>
                  </div>

                  <div className="learnGrid">
                    {visibleItems.map((r) => {
                      const isOpen = openKey === r.id;

                      return (
                        <article key={r.id} className={`learnHubCard learnHubCard--inline ${isOpen ? "is-open" : ""}`}>
                          <button
                            type="button"
                            className="learnHubCard__button"
                            onClick={() => setOpenKey(isOpen ? null : r.id)}
                            aria-expanded={isOpen}
                          >
                            <div className="learnHubCard__media">
                              <img src={r.image} alt={r.title} loading="lazy" className="learnHubCard__img" />
                              <div className="learnHubCard__mediaOverlay" />
                            </div>

                            <div className="learnHubCard__top">
                              <div className="learnHubCard__meta">
                                <span className="chip chip--muted">FAQ</span>
                              </div>
                              <div className="learnHubCard__arrow">{isOpen ? "−" : "→"}</div>
                            </div>

                            <div className="learnHubCard__title">{r.title}</div>
                            <div className="learnHubCard__excerpt">{r.excerpt}</div>
                          </button>

                          {isOpen ? (
                            <div className="learnInline">
                              <div className="learnInline__divider" />
                              <Answer text={r.answerText} />
                              <div className="learnInline__actions">
                                <Link className="btn btn--primary" to="/vehicles">
                                  Browse Vehicles
                                </Link>
                                <Link className="btn btn--ghost" to="/clubs">
                                  Memberships
                                </Link>
                              </div>
                            </div>
                          ) : null}
                        </article>
                      );
                    })}
                  </div>

                  {!query && items.length > 3 ? (
                    <div className="learnGroupActions">
                      <button
                        type="button"
                        className="btn btn--ghost"
                        onClick={() => toggleGroup(group)}
                      >
                        {showAll ? "Show Less" : `Show All (${items.length})`}
                      </button>
                    </div>
                  ) : null}
                </div>
              );
            })
          )}

          <div className="learnHubBottomCTA">
            <div className="learnHubBottomCTA__card">
              <div className="learnHubBottomCTA__title">Still have questions?</div>
              <p className="learnHubBottomCTA__text">Talk to our Concierge team and we’ll help.</p>
              <div className="learnHubBottomCTA__actions">
                <Link className="btn btn--primary" to="/clubs">
                  Compare Memberships
                </Link>
                <Link className="btn btn--ghost" to="/vehicles">
                  Browse Vehicles
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}